// @flow

/**
 * This is basically a manual wordwrap. It returns the last white space index
 * nearest to the maxLineLength to facilitate splitting a string into the
 * longest possible segments.
 */
const findBreakIndex = (sentence: string, maxLineLength: number) => {
  if (!sentence || !maxLineLength) {
    return null;
  }
  return maxLineLength < sentence.length
    ? sentence.slice(0, maxLineLength).lastIndexOf(' ')
    : sentence.length;
};

export default findBreakIndex;
